import React from "react";
import { Link } from "react-router-dom";
import SocialMediaLinks from "./SocialMediaLinks";
import { useTranslation } from "react-i18next";

import "./Footer.css";
// import config from "../../config";

function Footer() {
  const { t } = useTranslation();
  return (
    <footer id="footer">
      <div className="container p-5">
        <div className="columns is-gapless">
          <div className="column">
            <h4>Resources</h4>
            <ul className="_footer_safe_tour_list">
              <li className="_footer_safe_tour_list_item">
                <a className="_footer_safe_tour_list_link" href="#!">
                  Download
                </a>
              </li>
              <li className="_footer_safe_tour_list_item">
                <a className="_footer_safe_tour_list_link" href="#!">
                  Help Center
                </a>
              </li>
              <li className="_footer_safe_tour_list_item">
                <a className="_footer_safe_tour_list_link" href="#!">
                  Guide Book
                </a>
              </li>
              <li className="_footer_safe_tour_list_item">
                <a className="_footer_safe_tour_list_link" href="#!">
                  App Directory
                </a>
              </li>
            </ul>
          </div>
          <div className="column">
            <h4>Travellers</h4>
            <ul className="_footer_safe_tour_list">
              <li className="_footer_safe_tour_list_item">
                <a className="_footer_safe_tour_list_link" href="#!">
                  Why Travellers
                </a>
              </li>
              <li className="_footer_safe_tour_list_item">
                <a className="_footer_safe_tour_list_link" href="#!">
                  Enterprise
                </a>
              </li>
              <li className="_footer_safe_tour_list_item">
                <a className="_footer_safe_tour_list_link" href="#!">
                  Customer Stories
                </a>
              </li>
              <li className="_footer_safe_tour_list_item">
                <a className="_footer_safe_tour_list_link" href="#!">
                  Instagram post
                </a>
              </li>
            </ul>
          </div>
          <div className="column">
            <h4>Company</h4>
            <ul className="_footer_safe_tour_list">
              <li className="_footer_safe_tour_list_item">
                <a className="_footer_safe_tour_list_link" href="#!">
                  Travelling
                </a>
              </li>
              <li className="_footer_safe_tour_list_item">
                <a className="_footer_safe_tour_list_link" href="#!">
                  About Location
                </a>
              </li>
              <li className="_footer_safe_tour_list_item">
                <a className="_footer_safe_tour_list_link" href="#!">
                  Success
                </a>
              </li>
              <li className="_footer_safe_tour_list_item">
                <a className="_footer_safe_tour_list_link" href="#!">
                  Information
                </a>
              </li>
              <li className="_footer_safe_tour_list_item">
                <Link className="_footer_safe_tour_list_link" to="/contact-us">
                  {t("CONTACT_US")}
                </Link>
              </li>
              <li className="_footer_safe_tour_list_item">
                <Link className="_footer_safe_tour_list_link" to="/terms-and-conditions">
                  {t("TERMS_AND_CONDITIONS")}
                </Link>
              </li>
              <li className="_footer_safe_tour_list_item">
                <Link className="_footer_safe_tour_list_link" to="/privacy-policy">
                  {t("PRIVACY_POLICY")}
                </Link>
              </li>
            </ul>
          </div>
          <div className="column">
            <h4>Address</h4>
            <address className="mb-5 has-text-white" style={{ fontSize: '12px' }}>
              15A/21, Chowbaga Road,<br />
              Kolkata - 700039,<br />
              West Bengal, INDIA.<br /><br />
              Mobile: <a href="tel:+919674177686" className="supportEmail">+91-967-417-7686</a>
            </address>
            <h4>Get in Touch</h4>
            <p>
              Feel free to get in touch with us via email{" "}
              <a href="mailto:hello@tripaider.com" className="supportEmail">
                hello@tripaider.com
              </a>
            </p>
          </div>
        </div>
        <div className="columns">
          <div className="column">
            <SocialMediaLinks />
          </div>
        </div>
      </div>
    </footer >
  );
}

export default Footer;
